import { useEffect, useState } from "react";
import * as articlesApi from "@/api/articles.api";
import type { Article } from "@/types";

export function useArticleDetail(id: string | undefined) {
  const [article, setArticle] = useState<Article | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      setArticle(null);
      setError(false);
      return;
    }
    setLoading(true);
    setError(false);
    articlesApi
      .getArticle(id)
      .then(setArticle)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id]);

  return { article, loading, error };
}
